module.exports = __webpack_public_path__ + "img/vac-eiros.a155e19e.png";